<button
    matButton="filled"
    id="pay-now-btn"
    color="primary"
    (click)="validateAndPay()"
    [disabled]="disabled"
    type="submit"
    class="w-100 mt-1"
    [matTooltip]="tooltipMessage"
>
    @if (!isGuest) {
        <span>{{ isPaying ? 'PAYING' : 'PAY NOW' }}</span>
    }
    @if (isGuest) {
        <span> {{ isPaying ? 'PAYING' : 'PAY AS A GUEST' }} </span>
    }
    @if (isPaying) {
        <mat-icon class="ms-2 spinner-icon d-inline-flex" iconPositionEnd>
            <mat-spinner diameter="16"></mat-spinner>
        </mat-icon>
    }
</button>
